<div class="modal-header">
    <button class="btn-close" (click)="bsModalRef.hide()">
        <span></span>
        <span></span>
    </button>
</div>
<div class="modal-body" id="personnaliseproduct">
    <h2 class="product-family">{{product.familyName}}</h2>
    <h1 class="product-name">{{product.name}}</h1>
    <div class="product-infos">
        <div *ngIf="product.sizes?.length>0 && product.size>=0">
            <span class="price">
                {{product.sizes[product.size].price*product.qty|number:'1.2-2'}} €
            </span>
        </div>
        <div *ngIf="product.sizes?.length>0 && product.size>=0">
            <span class="nb">
                <ng-container *ngIf="product.sizes[product.size].level">
                    {{product.sizes[product.size].size}}
                </ng-container>
            </span>
        </div>
        <div>
            <div class="product-quantity vcenter">
                <div class="quantity">
                    <button (click)="incrQty()">+</button>
                    <p>{{product.qty}}</p>
                    <button (click)="decrQty()">-</button>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loading" id="loadingPage"></div>
    <div class="all">
        <div class="compositions" *ngIf="product.id && !loading">
            <p class="unavailableIng" *ngIf="unavComp>0 || unavOpt>0 || unavSupp>0">
                <i class="flaticon-exclamation "></i> : Ingredient indisponible pour le
                moment
            </p>
            <div class="gr-li" *ngIf="product.compositions?.length>0">
                <p class="p-par">
                    Compositions
                </p>
                <div class="d-grid">
                    <div class="check-group" *ngFor="let comp of product.compositions;let i=index"
                        id="wTooltipComp{{i}}">
                        <onoffswitch [(ngModel)]="comp.checked" [label]="comp.text" [available]="comp.available"
                            placement="bottom" containerClass="customClass">
                        </onoffswitch>
                    </div>
                </div>
            </div>
            <div class="gr-li" *ngIf="product.maxNbrIngOptions>0">
                <p class="p-par">
                    <ng-container *ngIf="(product.optionIngredients|groupByCategory).length>1">Options
                    </ng-container>
                    <ng-container *ngIf="(product.optionIngredients|groupByCategory).length==1">
                        {{(product.optionIngredients|groupByCategory)[0].category}}</ng-container>
                    : {{product.maxNbrIngOptions}} max
                </p>
                <div class="text-gray" id="obligatoryIngredient" *ngIf="product.obligatoryIngredient.length>0">
                    <div class="d-flex" style="margin: 0px 0px 10px 0px">
                        <label>Obligatoire</label>
                        <label *ngFor="let ing of product.obligatoryIngredient">
                            {{ing.category}} : {{ing.maxNbrIngOptions}} ingrédient(s)
                        </label>
                    </div>
                </div>
                <ul>
                    <li *ngFor="let c of product.optionIngredients|groupByCategory;let i=index">
                        <p class="p-col" *ngIf="(product.optionIngredients|groupByCategory).length>1">
                            {{c.category}} :
                        </p>
                        <div class="d-grid">
                            <div class="check-group" *ngFor="let opt of c.elements;let i=index">
                                <onoffswitch (change)="changeOption(opt)" [(ngModel)]="opt.checked" [label]="opt.text"
                                    [disabled]="!opt.available || (optChecked==product.maxNbrIngOptions && !opt.checked)"
                                    [available]="opt.available">
                                </onoffswitch>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="gr-li" *ngIf="product.hasSupp>0">
                <p class="p-par">
                    <span>Supplément</span>
                </p>
                <ul>
                    <li *ngFor="let c of product.supplements|groupByCategory;let i=index">
                        <p class="p-col">{{c.category}} :</p>
                        <div class="d-grid">
                            <div class="check-group" *ngFor="let supp of c.elements;let i=index">
                                <onoffswitch [(ngModel)]="supp.checked" [label]="supp.text"
                                    [available]="supp.available">
                                </onoffswitch>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <button class="add-to-cart btn" (click)="addToBasket()">
        <i class="flaticon-shopping"></i>
        <span>Modifer</span>
    </button>
</div>